jQuery(document).ready(function($){

    var query_param = ThemeJS.Functions.get_query_parameter('learning_path');
    
    if (query_param){
        $('.term-box').removeClass('active');
        $('[data-term-id="'+query_param+'"]').addClass('active');


        ThemeJS.Functions.send_ajax_request({
            data: {
                action: 'get_courses_by_learning_path_ajax',
                term_id: query_param
            },
            success: ( data ) => {
                $('.courses-by-learning-path-container').html('');

                $('.courses-by-learning-path-container').html(data);
            },
            error: ( data ) => {
               console.log( 'error!' );
            }
        });
    }
    
    $(document).on('click', '.learning-path-list .term-box a', function(e){
        e.preventDefault();
    });


    $(document).on('click', '.learning-path-list .term-box', function(){

        $('.term-box').removeClass('active');
        var term_id = $(this).data('term-id');
        $('.term-box[data-term-id="'+term_id+'"]').addClass('active');

        ThemeJS.Functions.send_ajax_request({
            data: {
                action: 'get_courses_by_learning_path_ajax',
                term_id: $(this).data('term-id')
            },
            success: ( data ) => {
                $('.courses-by-learning-path-container').html('');

                $('.courses-by-learning-path-container').html(data);
                console.log(data);
            },
            error: ( data ) => {
               console.log( 'error!' );
            }
        });

    })


    $(document).on('click', '.courses-list-box li', function(){

        var course_id = $(this).data('course-id');

        $('.course-description').hide();

        $('.course-description[data-course-id="'+course_id+'"]').show();

        $('.courses-list-box li').removeClass('active');
        $(this).addClass('active');
    });

   

    /* POSITION STICKY */
    $(window).scroll(function() {

        if ($('.learning-path-list-container').length > 0){
            var learning_path_start = $('.learning-path-list-container').offset().top;
            var learning_path_start_minus_header = learning_path_start - $('.header').height()
            var wH = $(window).height();
            var wS = $(this).scrollTop();   
            
    
            if (wS >=  learning_path_start_minus_header){
                $('.fixed-terms').addClass('show');
            }
            else{
                $('.fixed-terms').removeClass('show');
            }
        }
       
     });

     adjustFixedTermsPositioning();
     function adjustFixedTermsPositioning(){
         var headerHeight = $('.header').outerHeight();
         $('.fixed-terms').css('margin-top', headerHeight);
     }

     $('.fixed-terms-list').slick({
         slidesToShow: 7,
         dots: false,
         arrows: false,
         responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                },
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    centerMode: true,
                }
            },
        ]
     });
     matchTermBoxHeight();
     $(window).resize(function(){
        matchTermBoxHeight();
        matchTermBoxHeight();
     })

     function matchTermBoxHeight(){
        $('.fixed-terms-list .term-box').matchHeight();
     }



});